/*
 * Copyright (c) 2024. Haodong JU
 */
import hillo from 'hillo'
import { getCurrentDeviceId } from '@/model/dataLayer/service/RestaurantInfoService'
import { reservationHost } from '@/model/dataLayer/service/reservation/reservation'

const url = reservationHost + 'settings/weeklySetting/'

export async function saveWeeklySettings (item) {
  return (await hillo.jsonPost(url + 'save', {
    ...item,
    userId: await getCurrentDeviceId()
  }))
}

export async function deleteWeeklySettings (id) {
  return (await hillo.post(`${url}${id}/delete`, {}))
}

export async function getWeeklySettings () {
  return (await hillo.get(url + await getCurrentDeviceId(), {})).data
}
